import { Injectable, inject, ViewChild } from '@angular/core';
import { Subject, firstValueFrom, forkJoin, map, tap } from 'rxjs';
import { child, Database, equalTo, limitToLast, listVal, objectVal, onValue, orderByChild, push, query, ref, remove, update } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { iUsuario } from '../usuario/usuario.interface';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private database: Database = inject(Database);
  private http = inject(HttpClient);
  private referenciaLog: any;

  constructor() {
    this.referenciaLog = ref(this.database, `/log`);
  }

  getLogs (limit:number) {
    const refQueryLimit = query(this.referenciaLog, limitToLast(limit));
    return listVal(refQueryLimit, {keyField: 'id'});
  }

  addLog (error: any) {
    let data = {
      timestamp: new Date().toLocaleString(), 
      error: JSON.stringify(error) 
    };

    if(typeof data.error == 'string' && data.error == '{}' && error && error.message){
      data.error = error.message;
    }

    const idLogger = push(this.referenciaLog, data).key;
    return idLogger;
  }
}